import { supabaseClient, useUser } from '@auth-v2';
import { useQuery, useMutation } from '@tanstack/react-query';

import { Coach, fetchCoach, UpsertCoach, upsertCoach, deleteCoach } from '@data';

import { queryClient } from '../config/client';

export const getCoachKey = (userId: string) => ['coach', userId] as const;

export const useCoach = () => {
    const { data: user } = useUser();
    return useQuery<Coach | null>({
        queryKey: getCoachKey(user!.id),
        queryFn: () => fetchCoach(supabaseClient, user!.id),
        enabled: !!user,
    });
};

export const useUpsertCoach = () => {
    const { data: user } = useUser();
    return useMutation<Coach | null, unknown, Omit<UpsertCoach, 'userId'>>({
        mutationFn: async (coach: Omit<UpsertCoach, 'userId'>) => {
            return upsertCoach(supabaseClient, { ...coach, userId: user!.id });
        },
        onSuccess: (data) => {
            queryClient.setQueryData(getCoachKey(user!.id), data);
        },
    });
};

export const useDeleteCoach = () => {
    const { data: user } = useUser();
    return useMutation<void, unknown, void>({
        mutationFn: async () => {
            await deleteCoach(supabaseClient, user!.id);
        },
        onSuccess: () => {
            queryClient.setQueryData(getCoachKey(user!.id), null);
        },
    });
};
